import { Injectable } from "@angular/core";
import { Utility } from "@shared/services/utility.abstract";
import { APIService } from '@core/services/api.service';
import { CouponResponse } from "@core/models/promo-code.modal";
import { BookingSummary, ConfirmPayment } from "@core/models/booking.model";
import { AvailableOfferResponse } from "@core/models/super-admin-api.response.modal";

@Injectable({
  providedIn: 'root'
})
export class BookingFlowV1Service {
  constructor(private readonly apiService: APIService) { }
  fetchBookingSummary(bookingId: string) {
    const timeZone = Utility.getLocalTimeZone();
    return this.apiService.get<BookingSummary>(`BookingSlot/getBookingDetailById?id=${bookingId}&timeZone=${timeZone}`);
  }

  UpdateBookingByOffer(data) {
    return this.apiService.post('BookingSlot/UpdateOfferAndCredit', data)
  }

  createPaymentSession(data) {
    return this.apiService.post('User/CreatePaymentSession', data);
  }

  deleteBookingID(bookingId: string) {
    return this.apiService.delete(`BookingSlot/DeleteBooking?bookingId=${bookingId}`);
  }

  getUserByEmailId(data) {
    return this.apiService.post('User/GetUserByEmailId', data);
  }
  getGroupUserByEmailId(data) {
    return this.apiService.post('User/GetGroupUserByEmailId', data);
  }

  bookParkingSlotBySuperAdmin(data) {
    return this.apiService.post('BookingSlot/BookParkingSlotBySuperAdmin', data);
  }

  getOfferList(data) {
    return this.apiService.post<AvailableOfferResponse>('ParkingLot/GetOffersByBookingId', data)
  };

  checkCouponValidityWithBookingId(couponCode: string, bookingId: string) {
    return this.apiService.get<CouponResponse>(`User/CheckCouponValidity?couponCode=${couponCode}&bookingId=${bookingId}`)
  };

  createPaymentSessionBySuperAdmin(data) {
    return this.apiService.post('User/CreatePaymentSessionBySuperAdmin', data);
  }

  updateSlot(request: any) {
    return this.apiService.postWithAllResponse('BookingSlot/UpdateSlotByBookingIdBySuperAdmin', request)
  }

  confirmPayment(confirmPaymentData:ConfirmPayment){
    return this.apiService.post<ConfirmPayment>('User/StripePayment',confirmPaymentData)
  }

  calculateFareChargesOfBooking(request: any){
    return this.apiService.post('BookingSlot/CalculateFareChargesOfBooking',request)
  }

  createInvoiceLink(request: any) {
    return this.apiService.postWithAllResponse('Stripe/CreateInvoice', request);
  }

  getUserDetailById(data) {
    return this.apiService.get('User/GetUserDetailById', data);
  }
}
